'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _objectSpread = _interopDefault(require('@babel/runtime/helpers/objectSpread'));
var Cell = _interopDefault(require('../cell'));
var CellLeft = _interopDefault(require('../cell-left'));
var CellRight = _interopDefault(require('../cell-right'));
var Background = _interopDefault(require('../background'));
var utils = require('../utils');
var getSystem = require('@mx/util/get-system');

var system = getSystem.getSystem();
var index = utils.create({
  render: function render() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('background', {
      staticClass: "bill",
      attrs: {
        "color": "#F3F3F6"
      }
    }, [_c('div', {
      staticClass: "bill-list"
    }, [_vm._l(_vm.groups, function (group, index) {
      return _c('div', {
        key: index
      }, [_c('div', {
        staticClass: "bill-title"
      }, [group.left ? _c('span', {
        domProps: {
          "innerHTML": _vm._s(group.left)
        }
      }) : _vm._e(), _vm._v(" "), group.right ? _c('span', {
        domProps: {
          "innerHTML": _vm._s(group.right)
        }
      }) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "bill-items"
      }, _vm._l(group.items, function (item, index) {
        return _c('cell', {
          directives: [{
            name: "tap",
            rawName: "v-tap"
          }],
          key: index,
          class: {
            'bill-item-greyed': item.greyed
          },
          attrs: {
            "access": ""
          },
          on: {
            "click": function click($event) {
              _vm.onClick(item);
            }
          }
        }, [_vm._t("item", [_c('cell-left', [_c('div', {
          staticClass: "bill-date"
        }, [_c('h4', [_vm._v(_vm._s(item.dateAbove))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.dateBelow))])]), _vm._v(" "), _c('img', {
          staticClass: "bill-logo",
          attrs: {
            "src": item.logo
          }
        }), _vm._v(" "), _c('div', {
          staticClass: "bill-status"
        }, [_c('h4', {
          style: item.amountColor ? "color:".concat(item.amountColor) : ''
        }, [_vm._v(" " + _vm._s(item.amount) + " ")]), _vm._v(" "), _c('span', {
          staticClass: "ellipsis"
        }, [_vm._v(_vm._s(item.title))])])]), _vm._v(" "), _c('cell-right', {
          style: "color:".concat(item.statusColor),
          attrs: {
            "arrow": ""
          }
        }, [_vm._v(_vm._s(item.statusMsg))])], {
          item: item
        })], 2);
      }), 1)]);
    }), _vm._v(" "), _vm.isEmpty ? _c('div', {
      staticClass: "bill-empty"
    }, [_c('img', {
      attrs: {
        "src": "https://img.meituan.net/0.0.o/pay/fd75c17b0198cd41302bb06d8eed58363297.png"
      }
    }), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.emptyInfo)
      }
    })]) : _vm._e()], 2), _vm._v(" "), _c('div', {
      staticClass: "bill-info",
      domProps: {
        "innerHTML": _vm._s(_vm.buttomInfo)
      }
    })]);
  },
  staticRenderFns: [],
  name: 'bill',
  props: {
    data: Array,
    emptyInfo: {
      type: String,
      default: '暂无任何记录哦'
    },
    pending: {
      type: Boolean,
      default: false
    },
    hidden: {
      type: Boolean,
      default: false
    },
    offset: {
      type: Number,
      default: 500
    },
    scrollBox: {
      validator: function validator(value) {
        return system === 'node' || value instanceof HTMLElement;
      }
    }
  },
  components: {
    Cell: Cell,
    CellLeft: CellLeft,
    CellRight: CellRight,
    Background: Background
  },
  data: function data() {
    return {
      firstPendingFinished: false,
      param: {
        page: 0
      },
      finished: false,
      scrollAction: false
    };
  },
  computed: {
    groups: function groups() {
      var groups = {};
      var data = this.data;
      data && data.forEach(function (item) {
        item.groups.forEach(function (group) {
          var name = group.left;

          if (groups[name]) {
            groups[name].items = groups[name].items.concat(group.items);
          } else {
            groups[name] = _objectSpread({}, group);
          }
        });
      });
      return this.data ? groups : void 0;
    },
    isEmpty: function isEmpty() {
      return this.groups && !Object.keys(this.groups).length && this.firstPendingFinished;
    },
    buttomInfo: function buttomInfo() {
      return this.isEmpty ? '' : this.finished && this.param.page > 1 ? '没有更多了' : this.pending && this.param.page >= 1 ? "<div class=\"bill-loading\">\n                    <i class=\"icon-spin\"></i>\n                    <span>\u52A0\u8F7D\u4E2D...</span>\n                </div>" : '';
    }
  },
  mounted: function mounted() {
    this.$emit('load', this.param);
  },
  beforeDestroy: function beforeDestroy() {
    this.scrollHandler(false);
  },
  methods: {
    scrollHandler: function scrollHandler(action) {
      if (this.scrollAction !== action) {
        this.scrollAction = action;
        var target = this.scrollBox || window;
        target[action ? 'addEventListener' : 'removeEventListener']('scroll', this.onScroll);
      }
    },
    onScroll: function onScroll() {
      if (!this.pending && !this.hidden) {
        var root = this.scrollBox || document.documentElement;
        var scrollTop = root.scrollTop || document.body.scrollTop || window.scrollY;
        var fullHeight = Math.max(root.offsetHeight, root.scrollHeight);
        var scrollBottom = fullHeight - (scrollTop + root.clientHeight); // 如果传递了滚动容器，则执行新的计算逻辑
        // 容器的可滚动距离  -  滚动距离 - 容器可视高度  = 距离底部距离

        if (this.scrollBox) {
          scrollBottom = fullHeight - root.scrollTop - root.clientHeight;
        }

        if (scrollBottom <= this.offset) {
          this.$emit('load', this.param);
        }
      }
    },
    onClick: function onClick(orderNo) {
      this.$emit('click', orderNo);
    },
    watchPending: function watchPending() {
      if (!this.firstPendingFinished) {
        this.firstPendingFinished = !this.pending;
      }
    },
    watchData: function watchData() {
      var data = this.data;
      var lastData = data[data.length - 1];
      var count = lastData.groups ? lastData.groups.reduce(function (count, group) {
        return count + group.items.length;
      }, 0) : 0;
      this.finished = count < lastData.pageSize;
      this.param = {
        page: lastData.nextPage,
        offset: lastData.offset,
        extend: lastData.extend
      };
      this.scrollHandler(!this.finished);
    }
  },
  watch: {
    pending: function pending() {
      this.watchPending();
    },
    data: function data() {
      this.watchData();
    }
  }
});

exports.default = index;
